import { faFileExcel } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { saveAs } from "file-saver";
import { useState } from "react";

interface IExportExcelProps {
    baixarExcelController: () => Promise<Blob>;
    nomeArquivo: string;
}

export default function ExportExcel(props: IExportExcelProps) {
    const [loading, setLoading] = useState(false);

    return (
        <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 mt-22">
            <li
                className="nav-item"
                data-toggle="tooltip"
                title="ExportExcel"
                data-placement="left"
                data-original-title="ExportExcel"
            >
                <button
                    disabled={loading}
                    className="btn btn-sm btn-icon btn-bg-light btn-icon-success btn-hover-success"
                    onClick={() => {
                        setLoading(true);
                        props
                            .baixarExcelController()
                            .then((res) => {
                                saveAs(
                                    new Blob([res], {
                                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                                    }),
                                    props.nomeArquivo
                                );
                            })
                            .finally(() => setLoading(false));
                    }}
                >
                    {loading ? (
                        <div
                            className="spinner-border spinner-border-sm spinner-success text-success"
                            role="status"
                        >
                            <span className="sr-only">Carregando...</span>
                        </div>
                    ) : (
                        <FontAwesomeIcon icon={faFileExcel} />
                    )}
                </button>
            </li>
        </ul>
    );
}
